import {reducer, actions as actionBlanks, initialState} from "./state";
import {bindActionCreators} from "@reduxjs/toolkit";
import ApplicationForm from "@pages/partners/components/applicationForm/ApplicationForm";
import ApplicationService from "@api/partners/ApplicationService";
import {FC, useReducer, useRef, useState} from "react";
import FormBody from "./components/formBody/FormBody";
import {ApplicationDataState} from "@pages/partners/items/uralchem/form/types";
import st from "@pages/partners/items/uralchem/form/form.module.scss";

interface FormProps {
    hideWindow: () => void
    additionalInitial?: Partial<ApplicationDataState>
}

const Form: FC<FormProps> = ({hideWindow, additionalInitial}) => {

    const [item, dispatch]: [ApplicationDataState, any] = useReducer(reducer, {...initialState, ...additionalInitial});

    const actions = bindActionCreators(actionBlanks, dispatch);

    const options = {
        analysisObjects: [
            {id: 'soil', label: 'Почва'},
            {id: 'greenMass', label: 'Зеленая масса растений или корма'},
            {id: 'water', label: 'Вода'},
            {id: 'organicFertilizers', label: 'Органические удобрения'},
        ],
        testTypes: [
            {id: 'min', label: 'Минимальный (pH, Гумус, Фосфор, Калий)'},
            {id: 'opt', label: 'Оптимальный (Минимальный + Кальций, Магний, Натрий, Сера, Бор)'},
            {id: 'max', label: 'Максимальный (Оптимальный + Марганец, Цинк, Медь, Кобальт, Железо)'},
            {id: 'config', label: 'Персональный'},
        ],
        needSelection: [
            {id: 'yes', label: 'Да'},
            {id: 'no', label: 'Нет, отберем образцы сами'},
        ],
    };

    const replaceIdToValue = (item: ApplicationDataState): ApplicationDataState => {
        return {
            ...item,
            needSelection: options.needSelection.find(({id}) => id === item.needSelection)?.label,
            testType: item.testType !== 'config' ? options.testTypes.find(({id}) => id === item.testType)?.label : item.freeSoilTestList,
        };
    }

    const [containerExist, setContainerExist] = useState(false);
    const containerRef = useRef<HTMLDivElement | null>(null);

    return (
        <ApplicationForm
            headingText={'Заявка на услуги агролаборатории в «Уралхим»'}
            hideWindow={hideWindow}
            sendRequest={async () => ApplicationService.sendUralchem(replaceIdToValue(item))}
        >
            {(isLoading) => (
                <div className={st['inputs']} ref={(c) => {
                    containerRef.current = c;
                    setContainerExist(Boolean(c));
                }}>
                    {(!isLoading && containerExist) && <FormBody
                        item={item}
                        actions={actions}
                        options={options}
                        container={containerRef.current!}
                    />}
                </div>)}
        </ApplicationForm>
    );
};

export default Form;